export default __webpack_public_path__ + "static/media/gooChokiThumb.71aff98c.png";